
export const CheckMarkIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.55156 18L3.85156 12.3L5.27656 10.875L9.55156 15.15L18.7266 5.97501L20.1516 7.40001L9.55156 18Z" fill="#7C4DFF" />
    </svg>
);